import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { generalClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertScreenItem($input: ScreenItemInput) {
    upsertScreenItem(input: $input) {
      id
      name
    }
  }
`

const cleanRequest = compose(
  pick(['id', 'name', 'type', 'screenId', 'data', 'size']), //
  item => assoc('data', JSON.stringify(item.data), item),
  item => assoc('type', 'widget', item),
  item => assoc('size', compose(JSON.stringify, pick(['width', 'height']))(item.size), item)
)

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }) //
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveWidget = () => {
  const closeModal = useCloseModal()

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Screens'], client: generalClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
